// eslint-disable-next-line
export { default } from './{APP_PROFILE}'